module.exports = __webpack_public_path__ + "img/flower.be0ffbd7.svg";